import React, { useEffect, useState } from 'react';

import { ModelBase, PlayerObject, SmartHash } from "@models";
import { Creature, CreatureGroup } from "@dndModels";

import DandDAPI from "@dndUtilities/system_api";

import NonFSIndex from "@dndComponents/NonFSIndex";
import LoadingBox from "@components/input/LoadingBox";

const api = DandDAPI.getInstance();

export default function CreatureGroupIndex() {
  const [loading, setLoading] = useState(false);
  const [loading_message, setLoadingMessage] = useState("");
  const [creatures, setCreatures] = useState<Creature[]>([]);

  useEffect(() => {
    const load = () => {
      setLoading(true);
      const onComplete = (res: SmartHash) => {
        setCreatures(res.creature as Creature[]);
        setLoading(false);
      };
      const onProgress = (data_type: string, percentage: number ) => {
        if (percentage !== 0) {
          setLoadingMessage(`Loading Creatures ${Math.floor(percentage * 100)}%`);
        } else {
          setLoadingMessage(`Loading Creatures`);
        }
      };
      const onError = (message: string) => {
        setLoadingMessage(message);
      };
      api.getSetOfObjectsWithCallbacks({
        data_types: ["creature"],
        onProgress, onComplete, onError
      });
    };

    load();
  }, []);

  if (loading) {
    return (<LoadingBox message={loading_message} size={window.innerHeight * 0.5} height={window.innerHeight - 64} width={window.innerWidth - 24} />);
  } else {
    return (
      <NonFSIndex
        data_type="creature_group"
        extra={(obj: ModelBase | PlayerObject) => {
          if (obj instanceof CreatureGroup) {
            const my_creatures = creatures.filter(o => o.group_id === obj._id);
            return (<>{ my_creatures.map(o => o.name).join(", ") }</>);
          }
        }}
      />
    );
  }
}